
export class ClickyItem extends Phaser.GameObjects.Sprite {
    scene: Phaser.Scene;

    constructor(params: any) {
        super(params.scene, params.x, params.y, params.textureKey);

        // Hang onto scene
        this.scene = params.scene;

        this.initImage();
        this.initDraggable();
    }

    private initImage(): void {
        this.setScale(0.8);
        this.setSize(56, 56);
        this.setAlpha(1);
        this.setOrigin(0, 0);
        this.setInteractive();
    }

    update(): void { }

    private initDraggable(): void {
        this.on('pointerover', (a: Phaser.Input.Pointer) => {
            this.setAlpha(0.5);
        });

        this.on('pointerout', () => {
            this.clearAlpha();
        });

        this.scene.input.setDraggable(this);
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserDragDropDemo/objects/ClickyItem.ts